import React from 'react';
const Footer = () => (
  <>
   <footer className="footer">
        <div className="top">
            <div className="container">
                <div className="row">
                    <div className="col-md-3">
                        <div className="item">
                            <img src="img/logo.png" className="img-fluid" alt="" />
                        </div>
                    </div>
                        <div className="col-md-3 offset-1">
                        <div className="item">
                            <h3>Quick Links</h3>
                            <ul className="footer-explore-list list-unstyled">
                                <li><a className="" href='/'>Home</a></li>
                                <li><a className="" href='/about-us'>About us</a></li>
                              <li><a className="" href='/contact-us'>Contact us</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="item">
                            <h3>Get in touch</h3>
                            <ul className="footer-explore-list list-unstyled">
                                <li><a className="" href='/hotels'>Hotels</a></li>
                              <li><a className="" href='/events'>Events</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="item">
                            <h3>Connect Us</h3>
                            <div className="social mt-2">
                              <a href="https://www.facebook.com/p/Residency-Group-Hotels-100076310318273/"  target="_blank" rel="noopener noreferrer"><i className="ti-facebook"></i></a>
                              <a href="https://www.instagram.com/residencygrouphotels/?igsh=a3o3NzBqOXk5NHN3#"  target="_blank" rel="noopener noreferrer"><i className="ti-instagram"></i></a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="bottom">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-6 mb-3">
                        <p>© 2026 Residency Group Hotels. All right reserved.</p>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <p>Powered By : <a href="https://www.transindiatechnologies.com/" 
                        target="_blank"  rel="noopener noreferrer" aria-label="Trans India Technologies"> Trans India Technologies</a></p>
                    </div>

                </div>
            </div>
        </div>
    </footer>
  </>
);

export default Footer;
